"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Organization = void 0;
var ChangeCase = require("change-case");
var organizations_1 = require("../../schemas/organizations");
var common_1 = require("../common");
var Organization = /** @class */ (function (_super) {
    __extends(Organization, _super);
    function Organization(name, props) {
        if (props === void 0) { props = {}; }
        var _this = _super.call(this, __assign(__assign({}, Organization.defaultProps(name)), props)) || this;
        if (!props.id) { // @TODO evaluate
            _this.set({ id: undefined }); // Need Firebase/Auth module to set this
        }
        return _this;
    }
    Organization.defaultProps = function (name) {
        return {
            id: ChangeCase.constantCase(name),
            type: organizations_1.OrganizationType.ORGANIZATION,
            name: name,
            headquarters: common_1.Address.defaultProps(),
            offices: [],
            contact: null,
            services: [],
            products: [],
            areaServed: [],
            founder: null,
            founded: null,
            industry: [],
            entityType: null,
            isin: null,
            traded: null,
            subsidiaries: null,
            parent: null,
            financials: {
                revenue: null,
                operatingIncome: null,
                netIncome: null,
                totalAssets: null,
                totalEquity: null
            },
            employees: null,
            customers: null
        };
    };
    return Organization;
}(common_1.AbstractModel));
exports.Organization = Organization;
